import React from "react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-4 bg-white border-t border-gray-100">
      <div className="container mx-auto px-2">
        <div className="text-center text-gray-500 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-medium">
          © {currentYear} APEXIUM TECHNOLOGIES PRIVATE LIMITED.
        </div>
      </div>
    </footer>
  );
};

export default Footer;